import { supabase } from '../config/supabase';

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Please sign in to continue');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session.access_token}`,
  };
}

export async function sendTripNotification(event, payload) {
  const headers = await authHeaders();
  const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/trip-notify`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ event, payload }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    console.warn('Trip notification failed', data.error);
  }
}
